import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
//  import {handleNotificationAlertTrySelect ,handleNotificationAlertCatch } from './../../../common/method/handleNotificationAlert';
 import axiosCustom from './../../../common/components/apiConfig'; 

export const actionTypes={
    selectInstrument: "[selectInstrumenttest] Action",
    selectInstrumentLoading: "[selectInstrumentLoadingtest] Action",
    selectInstrumentAsync: "[selectInstrumentAsynctest] Action",
}

const inistiaState = {
    data:[],
    size:50,
    loading:false,
}

export const select_Instrument_Reducer = (state=inistiaState,{type,payload})=>{
    switch (type) {
        case actionTypes.selectInstrument:
            return {
                ...state,
                data: payload?.results,
                total : payload?.total,
            }
        case actionTypes.selectInstrumentLoading:
            return {
                ...state,
                loading: payload
            }
        default:
            return state
    }
}


function* handleWorker({payload}) {
    yield put({ type: actionTypes.selectInstrumentLoading, payload: true })

    let config = {
        url: "/stock/selectInstrument",
        method: "GET",
        params: { ...payload.data },
    }

    let data = {}


    try {
        let res = yield axiosCustom(config, data)

        if( !res?.data?.results){
            return
        }
        // let flag = handleNotificationAlertTrySelect(res, payload.dispatch)
        // if (!flag) return
        yield put({ type: actionTypes.selectInstrument, payload: res.data })

    } catch {
        // handleNotificationAlertCatch(payload.dispatch)
    } finally {
        yield put({ type: actionTypes.selectInstrumentLoading, payload: false })
    }

}

export function* selectInstrument () {
  yield takeEvery(actionTypes.selectInstrumentAsync, handleWorker);
}



